import { render, staticRenderFns } from "./LimitsEditModal.vue?vue&type=template&id=4910445e&"
import script from "./LimitsEditModal.vue?vue&type=script&lang=ts&"
export * from "./LimitsEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./LimitsEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports